export default __webpack_public_path__ + "static/media/wind_damage.0bfd423a.jpg";